// Stage config for sales pipeline UI
export const SALES_STAGES = [
  { id: "new", label: "New", color: "#9ca3af" },
  { id: "contacted", label: "Contacted", color: "#60a5fa" },
  { id: "meeting_scheduled", label: "Meeting Scheduled", color: "#d4af37" },
  { id: "in_discussion", label: "In Discussion", color: "#d4af37" },
  { id: "pipeline", label: "Pipeline", color: "#d4af37" },
  { id: "won", label: "Won", color: "#10b981" },
  { id: "loss", label: "Loss", color: "#ef4444" },
  { id: "hold", label: "Hold/Nurture", color: "#a78bfa" },
  // Pseudo-status used only in the Marketing Lead Ledger for rows still
  // awaiting a Sales Manager claim / delegation.
  { id: "pending_claim", label: "Pending Claim", color: "#d4af37" },
];

export const STAGE_LABEL = Object.fromEntries(SALES_STAGES.map((s) => [s.id, s.label]));
export const STAGE_COLOR = Object.fromEntries(SALES_STAGES.map((s) => [s.id, s.color]));

export function fileToDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function fmtCurrency(n) {
  const num = Number(n || 0);
  return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
}
